import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Button, Modal} from 'react-bootstrap';
import i18next from 'i18next';
import { Link } from 'react-router-dom';
import { TextInput } from '../TextInput';
import { ActionRoleTemplatesService, GroupsService } from '../../services';
import { SelectInput } from '../SelectInput';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import update from 'immutability-helper';
import { PageLevelAccess } from '../PageLevelAccess';

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = i18next.t('messages.please-enter-role-name')
  }
  if (!values.description) {
    errors.description = i18next.t('messages.please-enter-role-description')
  }
  if (values.matchPresent && !values.deviceGroupingMatch) {
    errors.deviceGroupingMatch = i18next.t('messages.please-select-business-structure')
  }
  return errors;
}

@connect(state => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping,
    form: state.form
  }
})
class RoleForm extends React.Component {

  constructor(props) {
    super(props);

    if (props.role) {
      const initData = {
        'name': props.role.name,
        'token': props.role.token,
        'description': props.role.description,
        'deviceGroupingMatch': props.role.deviceGroupingMatch ? this.getSelectedOption(props.groupingFilterOptions) : null,
        'templates': props.role.actionRoleTemplates.map(template => ({value: template.id, label: template.name, template: template}))
      };

      if(this.props.roleType.token == 'action_role') {
        initData['deviceGroupPresent'] = "True"
      }
      if (this.props.roleType.token == 'access_role') {
        initData['matchPresent'] = "True"
      }
      this.props.initialize(initData);
    } else {
      if (this.props.roleType.token == 'access_role') {
        const initData = {
          'matchPresent': "True"
        }
        this.props.initialize(initData);
      }
    }

    this.state = {
      groupings: null,
      showDeleteRoleModal: false
    }
  }

  getSelectedOption(groupings) {
    if (this.props.role.deviceGroupingMatch === '%') {
      return groupings[0].options[0];
    }

    let option = null
    groupings.map(grouping => {
      let foundOption = grouping.options.filter(option => option.fqn === this.props.role.deviceGroupingMatch.replace('%', ''));
      if (foundOption && foundOption.length > 0) {
        option = foundOption[0]
      }
    });
    return option
  }

  componentDidMount() {
    GroupsService.listAll().then(response => {
      this.setState({groupings: response.groups.map(group => ({ value: group.id, label: group.name, deviceGroup: group }))})
    }).catch(error => {
      console.error(error);
    });

    ActionRoleTemplatesService.getAll().then(response => {
      this.setState({
        actionRoleTemplates: response.actionRoleTemplates.sort((a, b) => {return a.sortOrder - b.sortOrder}).map(template => ({value: template.id, label: template.name, template: template}))
      });
    }).catch(error => {
      console.error(error);
    });

    if (this.props.roleType.token === 'action_role') {
      this.setState({
        adhocRoutes: this.props.role && this.props.role.uiRoutes ? this.props.role.uiRoutes : [],
        templateRoutes: this.props.role && this.props.role.actionRoleTemplates ? this.props.role.actionRoleTemplates.flatMap(template => template.uiRoutes.map(uiRoute => ({...uiRoute, template: template}))) : [],
      })
    }
  }

  toggleDeleteRoleModal() {
    this.setState({showDeleteRoleModal: !this.state.showDeleteRoleModal});
  }

  updateTemplateRoutes(selectedTemplates) {
    let templates = [];
    let templateRoutes = [];

    Object.keys(selectedTemplates).forEach(key => {
      if (key !== 'preventDefault') {
        let template = selectedTemplates[key].template;
        templates.push(template);

        template.uiRoutes.forEach(uiRoute => { 
          templateRoutes.push({...uiRoute, template: template})
        });
      }
    });

    this.setState({templateRoutes}, () => this.props.onTemplatesChanged(templates));
  }

  render() {
    if (this.state.groupings && this.state.actionRoleTemplates || this.props.roleType.token !== 'action_role') {
      return (
        <div className="op-content-box">
          <form onSubmit={this.props.handleSubmit}>
                  <Field
                    type="text"
                    name="name"
                    component={TextInput}
                    label={i18next.t('form-labels.role-name')}
                  />
                <Field
                  type="text"
                  name="description"
                  component={TextInput}
                  label={i18next.t('form-labels.role-description')}
                />
              {
                this.props.roleType.token == 'access_role' && this.props.groupingFilterOptions ? (
                  <div>
                    <label>{i18next.t('form-labels.business-structure')}</label>
                    <Field
                      name="deviceGroupingMatch"
                      component={SelectInput}
                      options={this.props.groupingFilterOptions}
                    />
                    <Field
                        component={TextInput}
                        name="matchPresent"
                        type="hidden"
                        style={{ height: 0 }}
                    />
                  </div>
                ) : null
              }

              {
                this.props.roleType.token === 'action_role' && this.state.actionRoleTemplates ? (
                  <div className="add-margin-bottom">
                    <label>{i18next.t('pages.roles.templates')}</label>
                    <Field
                      name = "templates"
                      options={this.state.actionRoleTemplates}
                      component={SelectInput}
                      isMulti
                      onChange={this.updateTemplateRoutes.bind(this)}
                    />
                  </div>
                ) : null
              }

            {
              this.props.roleType.token === 'action_role' && this.state.adhocRoutes && this.state.templateRoutes ? (
                  <div className="op-content-box">
                    <ul className="list-inline clearfix remove-margin-bottom">
                      <li className="pull-left"><h4 className="remove-margin-bottom">{i18next.t('pages.roles.screens')}</h4></li>
                    </ul>
                    <hr />
                    <RoutesList
                      allRoutes={this.props.allAvailableRoutes}
                      adhocRoutes={this.state.adhocRoutes}
                      templateRoutes={this.state.templateRoutes}
                      onRoutesChanged={this.props.onRoutesChanged}
                    />
                  </div>
              ) : null
            }

            <hr />

            <ul className="list-inline clearfix">
              <li><button type="submit" className="btn btn-primary">{this.props.role ? i18next.t('form-labels.update') : i18next.t('form-labels.save')}</button></li>
              <li><Link to={ this.props.backLinkWithParams ? this.props.backLinkWithParams.link : `/admin/roles`}><button className="btn btn-default">{i18next.t('form-labels.cancel')}</button></Link></li>
              {this.props.onDelete &&
              <PageLevelAccess to='/admin/roles/edit/:roleId#delete'>
                <li className="pull-right"><a className="btn btn-danger" onClick={this.toggleDeleteRoleModal.bind(this)}>{i18next.t('delete')}</a></li>
              </PageLevelAccess>}
            </ul>
            <Modal show={this.state.showDeleteRoleModal} onHide={this.toggleDeleteRoleModal.bind(this)}>
              <Modal.Header closeButton>
                <Modal.Title>{i18next.t('pages.roles.delete-role', this.props.form.RoleForm.values ? {roleName: this.props.form.RoleForm.values.name} : {roleName: ''})}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {i18next.t('messages.are-you-sure-delete')}
              </Modal.Body>
              <Modal.Footer>
                <a className="btn btn-danger" onClick={() => this.props.onDelete()}>{i18next.t('delete')}</a>
                <Button onClick={this.toggleDeleteRoleModal.bind(this)}>{i18next.t('form-labels.cancel')}</Button>
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      );
            } else {
              return (<div className="loader">{i18next.t('loading')}</div>)
            }
  } 
  

}

class RoutesList extends React.Component {
  constructor(props) {
    super(props);

    const adhocRoutes = this.props.adhocRoutes;
    const templateRoutes = this.props.templateRoutes;

    this.state = {
      adhocRoutes: adhocRoutes,
      templateRoutes: templateRoutes,
      adhocOverlap: this.checkForOverlap(adhocRoutes, templateRoutes)
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.templateRoutes.length !== this.props.templateRoutes.length) {
      this.setState({
        templateRoutes: this.props.templateRoutes,
        adhocOverlap: this.checkForOverlap(this.state.adhocRoutes, this.props.templateRoutes)
      });
    }
  }

  checkForOverlap(adhocRoutes, templateRoutes) {
    let adhocOverlap = false;

    for (let i = 0; i < adhocRoutes.length; i++) {
      if (templateRoutes.find(route => route.id === adhocRoutes[i].id)) {
        adhocOverlap = true;
        break;
      }
    }

    return adhocOverlap;
  }

  checkboxChanged(enabled, route) {
    if (enabled) {
      this.setState({
        adhocRoutes: update(this.state.adhocRoutes, { $push: [route] })
      }, () => {
        this.props.onRoutesChanged(this.state.adhocRoutes);
      });
    } else {
      this.setState({
        adhocRoutes: update(this.state.adhocRoutes, { $splice: [[this.state.adhocRoutes.findIndex(adhocRoute => adhocRoute.id === route.id), 1]] })
      }, () => {
        this.props.onRoutesChanged(this.state.adhocRoutes);
      });
    }
  }

  renderCheckboxes(data) {
    let enabledRoute = this.findEnabled(data.original.id);
    return (
      <div className="text-center">
        <input type="checkbox"
        onChange={e => { this.checkboxChanged(e.target.checked, data.original) }}
        checked={enabledRoute ? true : false}
        disabled={enabledRoute && enabledRoute.template ? true : false}
      />
      </div>
    );
  }

  findEnabled(id) {
    let enabledTemplateRoute = this.state.templateRoutes.find(route => route.id === id);
    return enabledTemplateRoute ? enabledTemplateRoute : this.state.adhocRoutes.find(route => route.id === id);
  }

  filterColumn(filter, row) {
    const id = filter.pivotId || filter.id
    return row[id] !== undefined ? String(i18next.t(`menus.from-router.${row[id]}`)).toLowerCase().includes(filter.value.toLowerCase()) : true
  }

  renderGrantedBy(data) {
    const enabledRoute = this.findEnabled(data.original.id);
    return enabledRoute ? enabledRoute && enabledRoute.template ? <span>{enabledRoute.template.name}</span> : <span>{i18next.t('pages.roles.this-role')}</span>: '';
  }

  render() {
    return (
      <div>
        { this.state.adhocOverlap ? (
        <h6 className="message-beware">
        {i18next.t('pages.roles.overlap-warning')}
        </h6>
        ): null}
        <div className="react-table-custom">
          <ReactTable
            className="-striped -highlight"
            ref="routesTable"
            data={this.props.allRoutes}
            showPaginationTop
            defaultSorted={[{
              id: 'uiRouteGroup.name',
              desc: false
            },{
              id: 'priority',
              desc: false
            }]}
            columns={[
                        {
                          Header: i18next.t('enabled'),
                          Cell: cell => this.renderCheckboxes(cell),
                          sortable: false,
                          minResizeWidth: 50, 
                          minWidth: 40
                        },
                        {
                          Header: i18next.t('table-headers.granted-by'),
                          accessor: "template",
                          Cell: cell => this.renderGrantedBy(cell),
                          minResizeWidth: 50
                        },
                        {
                          Header: i18next.t('table-headers.group'),
                          accessor: "uiRouteGroup.name",
                          Cell: cell => cell.value ? <span>{i18next.t(`menus.from-router.${cell.value}`)}</span> : <span></span>,
                          sortable: true,
                          filterable: true,
                          filterMethod: (filter, row) => this.filterColumn(filter, row),
                          minResizeWidth: 50
                        },
                        {
                          Header: i18next.t('table-headers.menu-group'),
                          accessor: "parentTitle",
                          Cell: cell => <span>{i18next.t(`menus.from-router.${cell.value}`)}</span>,
                          sortable: true,
                          filterable: true,
                          filterMethod: (filter, row) => this.filterColumn(filter, row),
                          minResizeWidth: 50
                        },
                        {
                          Header: i18next.t('table-headers.screen-title'),
                          accessor: "title",
                          Cell: cell => <span>{i18next.t(`menus.from-router.${cell.value}`)}</span>,
                          sortable: true,
                          filterable: true,
                          filterMethod: (filter, row) => this.filterColumn(filter, row),
                          minResizeWidth: 50,
                          style:{ 'whiteSpace': 'unset'}
                        },
                        {
                          Header: i18next.t('table-headers.description'),
                          accessor: "description",
                          minResizeWidth: 50,
                          style:{ 'whiteSpace': 'unset'}
                        }
                      ]}
          />
        </div>
      </div>
    );
  }

}

export default reduxForm({ form: 'RoleForm', validate })(RoleForm);
